 import JobForm from './JobForm'
import  './DynamicJobManager.css'

export const DynamicJobManager = () => {

  //explanation of code: https://share.google/aimode/Cb3rWbs1RF0N04k7H


 

  return (
    <div className='dynamic-Jobs-manager'>
     
            <JobForm />
      </div>
      
    )
}

